import { useState, useEffect, Fragment } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { parseLocaleDatetime } from "../../../common/util";
import { requests } from "../../../common/RestAPI";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";

import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";
import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';

import { useTranslation } from "react-i18next";
import CustomRadioBtn from "../../base/CustomRadioBtn";
import { VmImageMgmtData } from "./VmImageData";
import CustomText from "components/base/CustomText";


interface ArgsType {
    vm_image_id: string;
}

interface VmImageUpdateProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
    args?: ArgsType,
};

VmImageUpdate.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function VmImageUpdate(props:VmImageUpdateProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeUpdateYn, setExecuteUpdateYn] = useState(false);
    const [vmImageName, setVmImageName] = useState("");
    const [vmImageDesc, setVmImageDesc] = useState("");
    const [baseVmName, setBaseVmName] = useState("");
    const [vmImageNameWarnYn, setVmImageNameWarnYn] = useState(false);
    const [vmImageMgmtData, setVmImageMgmtData] = useState<VmImageMgmtData>(VmImageMgmtData);


    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);


    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {

                }
            } else {
                const successYn = checkVmImageData();
                if(successYn) {
                    setExecuteUpdateYn(true);
                }
            }

        }
    }, [props.clickedConfirmYn]);

    useEffect(() => {
        if(props.args?.vm_image_id) {
            loadVmImage();
        }
    }, [props.args]);

    useEffect(() => {
        if(executeUpdateYn) {
            executeUpdateVmImage();
        }
    }, [executeUpdateYn]);

    useEffect(()=>{
        setVmImageName(vmImageMgmtData.vm_image_name)
        setVmImageDesc(vmImageMgmtData.vm_image_description)
    },[vmImageMgmtData])


    function loadVmImage() {
        requests.get(PLATFORM_URL.VM_IMAGE + '/' + props.args?.vm_image_id)
        .then((response) => {
            setVmImageMgmtData(response.data);
        })
        .catch((error) => {
            if(props.showMessageCb){
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }


    function executeResult(result, closeYn, infoMessage) {
        setExecuteUpdateYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }


    function checkVmImageData() {
        setVmImageNameWarnYn(false);
        let message = "";
        let error = false;
        if(!vmImageName) {
            t("MESSAGE_VM_IMAGE_INFO_ENTER_ERROR_MESSAGE")
            setVmImageNameWarnYn(true);
            error = true;
        }
        if(error === true)
            if(props.showMessageCb){
                props.showMessageCb(message);
            }
        return !error;
    }


    function executeUpdateVmImage() {
        const body = {
            vm_image:{
                vm_image_name: vmImageName || vmImageMgmtData.vm_image_name,
                vm_image_description: vmImageDesc || vmImageMgmtData.vm_image_description,
                share_type_code: vmImageMgmtData.share_type_code,
                os_type_code: vmImageMgmtData.os_type_code,
                protect_yn: vmImageMgmtData.protect_yn
            }
        };

        requests.put(PLATFORM_URL.VM_IMAGE + '/' + props.args?.vm_image_id, body)
        .then((response) => {
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else if(response.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_VM_IMAGE_UPDATE_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }

        })
        .catch((error) => {
            if(error.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_VM_IMAGE_UPDATE_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        });
    }

    function selectButton(id, type){
        setVmImageMgmtData({...vmImageMgmtData, share_type_code: type});
    }

    return (
        <View>
            {
                stepIndex === 0 ?
                // 이름, 설명, 사용 유형, 사용 대상
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("VM_IMAGE_UPDATE_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("VN_IMAGE_NAME_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput
                                key={2}
                                width={570} height={36}
                                value={vmImageMgmtData.vm_image_name}
                                type={"text"}
                                activeYn={true}
                                inputCb={setVmImageName}
                                warnYn={vmImageNameWarnYn}
                                placeHolderText={t("NAME_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowTopAlignContainer}>
                            <Text style={style.columnText}>
                                {t("DESCRIPTION_TEXT")}
                            </Text>
                            <TextArea
                                key={3}
                                width={570}
                                height={100}
                                value={vmImageMgmtData.vm_image_description}
                                type={"text"}
                                activeYn={true}
                                inputCb={setVmImageDesc}
                                warnYn={false}
                                placeHolderText={t("DESCRIPTION_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowDivContainer}/>
                        {VmImageMgmtData.vm_image_type_code === "SNAP" ?
                        <Fragment>
                            <View style={style.rowContainer}>
                                <Text style={style.columnText}>
                                    {t("VM_TEXT")}
                                </Text>
                                <Text style={style.dataText}>
                                    {baseVmName ? baseVmName : ""}
                                </Text>
                            </View>
                            <View style={style.rowDivContainer}/>
                        </Fragment>
                        : null}

                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("IMAGE_STATUS_TEXT")}
                            </Text>
                            <View style={{flexDirection: "row", alignItems: "center"}}>
                                {
                                    vmImageMgmtData.vm_image_status_code === "ACT" ? <StatusStableImg style={style.statusImg}/> : <StatusBlockImg style={style.statusImg}/>
                                }
                                <Text style={{
                                    ...style.dataText,
                                    color: vmImageMgmtData.vm_image_status_code === "ACT" ? "#3a8344" : "#8c8c8c",
                                }}>
                                    {
                                        vmImageMgmtData.vm_image_status_code === "ACT" ? "Active"
                                        : vmImageMgmtData.vm_image_status_code === 'QUEU' ? "Queued"
                                        : vmImageMgmtData.vm_image_status_code === 'SAVE' ? "Saving"
                                        : vmImageMgmtData.vm_image_status_code === 'UPLD' ? "Uploading"
                                        : vmImageMgmtData.vm_image_status_code === "IMPT" ? "Importing"
                                        : vmImageMgmtData.vm_image_status_code === 'DACT' ? "Deactive"
                                        : vmImageMgmtData.vm_image_status_code === 'KILL' ? "Killed"
                                        : vmImageMgmtData.vm_image_status_code === 'DEL' ? "Deleted"
                                        : vmImageMgmtData.vm_image_status_code === 'PDDEL'  ? "PendingDeleted"
                                        : "None"
                                    }
                                </Text>
                            </View>
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("FILE_SIZE_TEXT")}
                            </Text>
                            <Text style={style.dataText}>
                                {vmImageMgmtData.real_size_mb} MB
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("VIRT_VOLUME_SIZE_TEXT")}
                            </Text>
                            <Text style={style.dataText}>
                                {vmImageMgmtData.virt_size_mb} MB
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("DISK_FORMAT_TEXT")}
                            </Text>
                            <Text style={{...style.dataText, color: "#3a8344"}}>
                                {
                                    vmImageMgmtData.vm_image_format_type_code === 'ISO' ? "ISO"
                                    : vmImageMgmtData.vm_image_format_type_code === 'QCOW' ? "QCOW2"
                                    : vmImageMgmtData.vm_image_format_type_code === 'RAW' ? "RAW"
                                    : vmImageMgmtData.vm_image_format_type_code === 'VDI' ? "VDI"
                                    : vmImageMgmtData.vm_image_format_type_code === 'VHD' ? "VHD"
                                    : vmImageMgmtData.vm_image_format_type_code === 'VMDK' ? "VMDK"
                                    : "None"
                                }
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("GUEST_OS_TEXT")}
                            </Text>
                            <Text style={{...style.dataText, color: "#7066f1"}}>
                                {vmImageMgmtData.os_type_code}
                            </Text>
                        </View>
                        <View style={style.rowDivContainer}/>
                    </View>
                    <Text style={style.titleText}>{
                        t("SHARE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("SHARE_CATEGORY_TEXT")}
                            </Text>
                            <CustomRadioBtn
                                id={"ImageShareType"}
                                type={"PUB"}
                                size={18}
                                activeYn={true}
                                checked={vmImageMgmtData.share_type_code === "PUB" ? true: false}
                                selectCb={selectButton}
                                label={"공용(Pubilc)"}
                                labelStyle={labelStyle}
                            />
                            <View style={{width: 44}}/>
                             <CustomRadioBtn
                                id={"InstanceShareType"}
                                type={"PRJ"}
                                size={18}
                                activeYn={true}
                                checked={vmImageMgmtData.share_type_code === "PRJ" ? true: false}
                                selectCb={selectButton}
                                label={"개인(프로젝트)"}
                                labelStyle={labelStyle}
                            />
                            <View style={{width: 44}}/>
                            {
                                vmImageMgmtData.share_type_code === "HDN"
                                ?
                                <CustomRadioBtn
                                    id={"InstanceShareType"}
                                    type={"HDN"}
                                    size={18}
                                    activeYn={false}
                                    checked={vmImageMgmtData.share_type_code === "HDN" ? true: false}
                                    selectCb={selectButton}
                                    label={"숨김(사용불가)"}
                                    labelStyle={labelStyle}
                                />
                                : null
                            }
                        </View>
                        {
                            vmImageMgmtData.share_type_code !== "HDN" ?
                            <View style={style.rowContainer}>
                                <Text style={style.columnText}>
                                    {t("PROJECT_INFO_TEXT")}
                                </Text>
                                <CustomTextInput
                                    key={112}
                                    width={300} height={36}
                                    value={vmImageMgmtData.project.project_name}
                                    type={"text"}
                                    activeYn={false}
                                    inputCb={(e) => {}}
                                    warnYn={false}
                                />
                            </View>
                            : null
                        }
                        <Text style={{...style.rowDescribeContainer, marginBottom: 20}}>
                            {t("MESSAGE_SHARED_TYPE_CHANGE_DESCRIBE_MESSAGE")}
                        </Text>
                        <View style={style.rowDivContainer}/>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("UPDATE_DATE_TEXT")}
                            </Text>
                            <Text style={{...style.dataText, color: "#9ea0a5"}}>
                                {vmImageMgmtData.update_ts ? parseLocaleDatetime(vmImageMgmtData.update_ts) : ""}
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("CREATE_DATE_TEXT")}
                            </Text>
                            <Text style={{...style.dataText, color: "#9ea0a5"}}>
                                {vmImageMgmtData.create_ts ? parseLocaleDatetime(vmImageMgmtData.create_ts) : ""}
                            </Text>
                        </View>
                    </View>
                </View>
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",

    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 12,
        color: "#8c8c8c"
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    statusImg: {
        marginRight: 3
    },
    dataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    }
});


const labelStyle = {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#333"
}